var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"main"},[(_vm.isSubmitting)?_c('div',{staticClass:"loader-container"},[_c('LoaderBlock')],1):[_c('SideMenu',{attrs:{"entries":_vm.entries},on:{"logout":_vm.logout,"invoice":_vm.invoice}}),_c('router-view',{key:_vm.routerViewKey})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }